import { render, staticRenderFns } from "./UserAddNewsEditor.vue?vue&type=template&id=4b969aa7&scoped=true&"
import script from "./UserAddNewsEditor.vue?vue&type=script&lang=js&"
export * from "./UserAddNewsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b969aa7",
  null
  
)

export default component.exports